import { ATHENS_GRAY } from "@/controls/shared/constants/colors";
import {
	ErrorModal,
	HelmetDexteel,
	ShiftDayNavigatorControl,
	useShiftNavigator,
} from "@dexteel/mesf-core";
import { Box, Grid2 as Grid, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
	LazyBackDropLoading,
	LazyLoading,
} from "../../../controls/LazyLoading";
import { NotificationSnackBar } from "../../../controls/snackbars/notification-snackbar";
import { getCountersByShift } from "../repositories/ProductionRepository";
import { useCasterCountersContext } from "./CasterCountersContext";
import { CasterCountersTable } from "./components/CasterCountersTable";

type Props = {};
export const CasterCountersPage = (props: Props) => {
	const { state, actions } = useCasterCountersContext();
	const [showDeletedProcesses, setShowDeletedProcesses] = useState(false);

	const { shiftInfo } = useShiftNavigator();

	const getDataFromAPI = async () => {
		actions.setIsLoadingGrid(true);
		const resp = await getCountersByShift(
			shiftInfo?.CurrentShiftId || 0,
			showDeletedProcesses,
		);
		if (resp.ok && resp.data.tables.length > 0) {
			actions.setCounters(resp.data.tables[0].rows);
		} else {
			console.log("something happened 2");
		}
		actions.setIsLoadingGrid(false);
	};

	useEffect(() => {
		(async () => {
			await getDataFromAPI();
		})();
	}, [shiftInfo, showDeletedProcesses]);

	if (!state.isLoadingPage) {
		return (
			<>
				<HelmetDexteel title={`Caster Counters`} />
				<Paper
					elevation={0}
					style={{
						width: "100%",
						padding: "15px 20px 10px",
						height: "93vh",
						backgroundColor: ATHENS_GRAY,
					}}
				>
					<LazyBackDropLoading open={state.isLoadingBackground} />
					<Grid container>
						<Grid size={{ xs: 12 }} style={{ marginBottom: "10px" }}>
							<Typography variant="h5" style={{ fontWeight: 600 }}>
								Caster Counters
							</Typography>
						</Grid>

						<Grid size={{ xs: "auto" }} style={{ display: "flex" }}>
							<Paper
								elevation={1}
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box sx={{ p: 1 }}>
									<ShiftDayNavigatorControl withPaper={false} />
								</Box>
							</Paper>
						</Grid>
						<Grid size={{ xs: 12 }} style={{ marginTop: "10px" }}>
							<CasterCountersTable
								loadingGrid={state.isLoadingGrid}
								rows={state.counters || []}
								showDeletedProcesses={showDeletedProcesses}
							/>
						</Grid>
					</Grid>
					<ErrorModal
						error={state.errorMessage}
						onHide={() => actions.setErrorMessage("")}
					/>
					<NotificationSnackBar
						message={state.notificationMessage}
						onHide={() => actions.setNotificationMessage("")}
					/>
				</Paper>
			</>
		);
	}
	return <LazyLoading />;
};
